import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 10,
  },
  title: {
    marginBottom: 5,
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font18PX,
    color: theme.colors.light.freshPowder,
  },
  divider: {
    height: 1,
    width: '100%',
    display: 'flex',
    border: 'none',
    backgroundColor: theme.colors.dark.steelBlue,
  },
}));
